import * as THREE from 'three';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';

export class J3GUIHelper extends EventTarget {
    panel: GUI;

    constructor(public scene: THREE.Scene, public gui) {
        super();
        this.panel = new GUI({ title: gui.title, width: gui.width });
        if (gui.hide) {
            this.panel.hide();
        }
        let settings = {};

        for (const group of gui.groups) {
            let target;
            if (group.folder) {
                target = this.panel.addFolder(group.category);
            } else {
                target = this.panel;
            }
            for (const item of group.items) {
                //settingsオブジェクトに初期値を登録
                if (Array.isArray(item.value)) {
                    settings[item.name] = item.value[0];   //配列の場合は最初の要素をデフォルト値にする
                } else if (typeof (item.value) == 'object') {
                    settings[item.name] = 0;   //名前付き数値の場合は'0'をデフォルト値にする
                } else {
                    settings[item.name] = item.value;
                }

                // GUI要素（スライダーかそれ以外か）
                if (typeof (item.value) == 'number' && Array.isArray(item.range)) {
                    //スライダー
                    if (item.range.length > 2) {
                        target.add(settings, item.name, item.range[0], item.range[1], item.range[2])
                            .onChange((value) => this.ParamChanged(group.category, item.name, value, item.range[2]));
                    } else {
                        target.add(settings, item.name, item.range[0], item.range[1])
                            .onChange((value) => this.ParamChanged(group.category, item.name, value));
                    }

                } else {
                    //非スライダー 値によって適切なGUI要素が自動的に適用される
                    target.add(settings, item.name, item.value)
                        .onChange((value) => this.ParamChanged(group.category, item.name, value));
                }

            }
            //フォルダの初期開閉
            if (group.folder) {
                if (group.open) {
                    target.open();
                } else {
                    target.close();
                }
            } 
        }
    }

    ParamChanged(category: string, name: string, value: number | boolean | string, step: number = 1) {
        let event = new CustomEvent('change', { detail: { category: category, name: name, value: value, step: step } });
        //console.log('change', category, name, value);
        this.dispatchEvent(event);
    }

    Show() {
        this.panel.show();
    }
    Hide() {
        this.panel.hide();
    }
}